/* eslint-disable react/no-unused-prop-types, react/forbid-prop-types */
const React = require('react');
const PropTypes = require('prop-types');
const MeliGA = _ref => {
  let {
    children
  } = _ref;
  // Allow the rendering of children elements
  if (children) {
    return React.Children.only(children);
  }

  // Do not render the MeliGA itself in place where it was called
  // since the Analytics code should be always located in specific place of the header
  return null;
};
MeliGA.propTypes = {
  section: PropTypes.string.isRequired,
  secure: PropTypes.bool,
  search: PropTypes.string,
  dimensions: PropTypes.object,
  metrics: PropTypes.object,
  pathFromRoot: PropTypes.array,
  business: PropTypes.string,
  pageVertical: PropTypes.string,
  pageLayout: PropTypes.string,
  pageCategoryL1: PropTypes.string,
  privatePage: PropTypes.string,
  isDeferred: PropTypes.bool,
  enableOptimize: PropTypes.bool,
  optimizeId: PropTypes.string,
  preventOptimizeFlickering: PropTypes.bool,
  children: PropTypes.any
};
MeliGA.MeliGA = MeliGA;
module.exports = MeliGA;